import { NgModule } from '@angular/core';
import { CompanyComponent } from './company.component';
import { AddcompanyComponent } from '../addcompany/addcompany.component';
import { EditcompanyComponent } from '../editcompany/editcompany.component';
import { DetailcompanyComponent } from '../detailcompany/detailcompany.component';
import { CompanyAttachmentComponent } from '../company-attachment/company-attachment.component';
import { CompanyRoutingModule } from './company-routing.module';
import { SharedModule } from '../../../shared/shared.module';

@NgModule({
  declarations: [
    CompanyComponent,
    AddcompanyComponent,
    EditcompanyComponent,
    DetailcompanyComponent,
    CompanyAttachmentComponent
  ],
  imports: [
    CompanyRoutingModule,
    SharedModule
  ]
})

export class CompanyModule {}
